import PromiseCache from './promise-cache';
export default function (umbrella) {
  var fetch = umbrella.fetch;
  var cache = new PromiseCache();
  var brandingURL = "https://".concat(window.location.hostname, "/api/v1/branding");
  function getStyles() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, body;
      options = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      body = JSON.stringify(options);
      return Promise.resolve(cache("getStyles:".concat(body), function () {
        return new Promise(function ($return, $error) {
          var res, data;
          return Promise.resolve(fetch("".concat(brandingURL, "/styles"), {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            body: body
          })).then(function ($await_1) {
            try {
              res = $await_1;
              return Promise.resolve(res.json()).then(function ($await_2) {
                try {
                  data = $await_2;
                  if (res.ok) {
                    return $return(data);
                  } else {
                    return $error(data);
                  }
                  return $return();
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      })()).then($return, $error);
    });
  }
  umbrella.getStyles = getStyles;
}
//# sourceMappingURL=branding.js.map